<template>
  <section
    v-if="itemDescriptions?.length"
    class="skin-descriptions"
  >
    <h2>{{ t('Description') }}</h2>
    <div class="skin-descriptions_wrap">
      <!--      <div -->
      <!--          v-for="(desc) of descriptions" -->
      <!--          :key="desc.name" -->
      <!--          class="skin-descriptions&#45;&#45;item card-dark" -->
      <!--      > -->
      <!--        <div class="skin-descriptions&#45;&#45;item_header"> -->
      <!--          <i :class="`i-${desc.name}`"></i> -->
      <!--          <h3>{{ -->
      <!--              t(`descriptions.${desc.name}.title`, { -->
      <!--                name: props.item.locals?.localed_name || -->
      <!--                    props.item.market_hash_name -->
      <!--              }) -->
      <!--            }}</h3> -->
      <!--        </div> -->
      <!--        <div class="skin-descriptions&#45;&#45;item_body"> -->
      <!--          <p v-html="desc.text"></p> -->
      <!--        </div> -->
      <!--      </div> -->
      <template
        v-for="(desc) of itemDescriptions"
        :key="desc.title"
      >
        <div
          v-if="desc.value"
          class="skin-descriptions--item card-dark"
        >
          <div class="skin-descriptions--item_header">
            <svg
              v-if="desc.icon"
              height="24"
              width="24"
            >
              <use :xlink:href="`/icons/sprite.svg#${desc.icon}`" />
            </svg>
            <i
              v-else
              class="i-rarity"
            />
            <h3>{{ desc.title }}</h3>
          </div>
          <div class="skin-descriptions--item_body">
            <p v-html="desc.value" />
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { Description, ItemPageInfo } from '~/graphql/generated/schema-types';

const props = defineProps<{
  item: ItemPageInfo
}>();

const icons: Record<string, string> = {
  'Overview': 'i-info',
  'Rarity': 'i-diamond',
  'History': 'clock',
  'Popularity': 'flame',
  'Compatibility': 'i-dumbell',
  'Unique Features': 'settings',
  'Event': 'calendar-star',
  'Trivia': 'i-info',
  'Skin Designer': 'i-brush',
  'Technical Features': 'settings',
  'Reviews and Ratings': 'feedback',
  'Historical Significance': 'clock',
  'Reasons for Popularity': 'flame',
  'Influential Events': 'calendar-star',
  'Creation Story': 'i-info',
  'Symbolism and Design Elements': 'palette',
  'Emotional Connection': 'i-smile',
  'Impact on Community': 'community',
  'Usage in Esports': 'gamepad',
  'Player Stories': 'i-book',
};

const { locale, t } = useI18n();

const itemDescriptions = computed(() => {
  const replacements: Record<string, string> = {
    'lang': locale.value === 'en' ? '' : locale.value,
    'designer-name': props.item.designer_name || 'Valve',
    'designer-url': props.item.designer_link || '#',
  };

  return props.item.descriptions?.filter(desc => desc?.value && desc?.title)?.map((description) => {
    let newValue = (description as Description).value;

    for (const [key, value] of Object.entries(replacements)) {
      const regexCurly = new RegExp(`{${key}}`, 'g');
      const regexSquare = new RegExp(`\\[${key}\\]`, 'g');

      newValue = newValue?.replace(regexSquare, value);
      newValue = newValue?.replace(regexCurly, value);
    }
    newValue = newValue?.replace('https://csmarketcap.com', '').replace('/collections', '/containers');

    if (locale.value === 'en') {
      // Удаляем переменную {lang} и последующий слеш, если locale === 'en'
      newValue = newValue?.replace(/\/\{lang\}\//g, '/')?.replace(/\{lang\}/g, '');
    }

    newValue = newValue?.replace(/\/\//g, '/');
    // Заменяем теги <a> на <span>
    newValue = newValue?.replace(/<a\b[^>]*>/g, '<span>').replace(/<\/a>/g, '</span>');

    return {
      title: (description as Description).title,
      value: newValue,
      // @ts-ignore
      icon: icons[(description as Description).title],
    };
  });
});
</script>

<style lang="scss" scoped>
.skin-descriptions {
  &_wrap {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    @media screen and (max-width: 768px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &--item {
    border-radius: 1rem;

    p {
      font-size: 1.6rem;
      line-height: 2;
      color: var(--surfaces-on-surface);
      opacity: 0.8;
      font-weight: 400;
    }

    &_header {
      min-height: 3rem;
      display: flex;
      align-items: flex-start;
      font-size: 1.8rem;
      gap: 0.8rem;
      margin-bottom: 1.6rem;

      i, svg {
        font-size: 2.4rem;
        margin-top: 4px;
        color: var(--accent-secondary);
      }
    }

    &_body p {
      text-align: justify;

      &:deep(a) {
        text-decoration: underline;
      }
    }
  }
}
</style>
